export const TOP_STYLES = [
  { value: 'default', label: 'Bald' },
  { value: 'hat', label: 'Hat' },
  { value: 'hijab', label: 'Hijab' },
  { value: 'turban', label: 'Turban' },
  { value: 'winterHat1', label: 'Winter Hat 1' },
  { value: 'winterHat04', label: 'Winter Hat 2' },
  { value: 'bigHair', label: 'Long Hair' },
  { value: 'bob', label: 'Bob Cut' },
  { value: 'curly', label: 'Short Curly' },
  { value: 'curvy', label: 'Long Hair Curvy' },
  { value: 'frida', label: 'Frida' },
  { value: 'straight01', label: 'Long Hair Straight' },
  { value: 'straight02', label: 'Long Hair Straight 2' },
  { value: 'straightAndStrand', label: 'Long Hair Straight 3' },
  { value: 'longButNotTooLong', label: 'Medium Hair Straight' },
  { value: 'miaWallace', label: 'Mia Wallace' },
  { value: 'dreads', label: 'Long Dreads' },
  { value: 'dreads01', label: 'Short Dreads' },
  { value: 'dreads02', label: 'Medium Dreads' },
  { value: 'frizzle', label: 'Frizzle' },
  { value: 'fro', label: 'Afro' },
  { value: 'froBand', label: 'Afro Band' },
  { value: 'shaggy', label: 'Shaggy' },
  { value: 'shaggyMullet', label: 'Shaggy Mullet' },
  { value: 'shavedSides', label: 'Shaved Sides' },
  { value: 'shortCurly', label: 'Short Curly' },
  { value: 'shortFlat', label: 'Short Flat' },
  { value: 'shortRound', label: 'Short Round' },
  { value: 'shortWaved', label: 'Short Waved' },
  { value: 'sides', label: 'Sides' },
  { value: 'theCaesar', label: 'Caesar' },
  { value: 'theCaesarAndSidePart', label: 'Side Part Caesar' },
];

export const ACCESSORIES = [
  { value: 'default', label: 'Default' },
  { value: 'eyepatch', label: 'Eyepatch' },
  { value: 'kurt', label: 'Kurt' },
  { value: 'prescription01', label: 'Prescription 01' },
  { value: 'prescription02', label: 'Prescription 02' },
  { value: 'round', label: 'Round' },
  { value: 'sunglasses', label: 'Sunglasses' },
  { value: 'wayfarers', label: 'Wayfarers' },
];

export const ACCESSORIES_COLOR = [
  { value: '2c1b18', label: 'Black' },
  { value: 'F5F5F5', label: 'White' },
  { value: '2151B1', label: 'Sapphire' },
  { value: 'E02B2E', label: 'Scarlet' },
  { value: 'BDE12B', label: 'Lime Moss' },
  { value: '893E04', label: 'Saddle Brown' },
  { value: '6F6D6B', label: 'Gray' },
  { value: 'DC948E', label: 'Coral' },
];

export const HAIR_COLOR = [
  { value: 'a55728', label: 'Auburn' },
  { value: '2c1b18', label: 'Black' },
  { value: 'd6b370', label: 'Blonde' },
  { value: '724133', label: 'Brown' },
  { value: 'f59797', label: 'Pastel Pink' },
  { value: 'ecdcbf', label: 'Platinum' },
  { value: 'c93305', label: 'Red' },
  { value: 'e8e1e1', label: 'Silver Gray' },
  { value: '2151B1', label: 'Sapphire' },
  { value: '58C466', label: 'Emerald' },
];

export const FACIAL_HAIR = [
  { value: 'default', label: 'Default' },
  { value: 'beardLight', label: 'Beard Light' },
  { value: 'beardMedium', label: 'Beard Medium' },
  { value: 'beardMajestic', label: 'Beard Majestic' },
  { value: 'moustacheFancy', label: 'Moustache Fancy' },
  { value: 'moustacheMagnum', label: 'Moustache Magnum' },
];

export const CLOTHING = [
  { value: 'blazerAndShirt', label: 'Blazer Shirt' },
  { value: 'blazerAndSweater', label: 'Blazer Sweater' },
  { value: 'collarAndSweater', label: 'Collar Sweater' },
  { value: 'graphicShirt', label: 'Graphic Shirt' },
  { value: 'hoodie', label: 'Hoodie' },
  { value: 'overall', label: 'Overall' },
  { value: 'shirtCrewNeck', label: 'Shirt Crew Neck' },
  { value: 'shirtScoopNeck', label: 'Shirt Scoop Neck' },
  { value: 'shirtVNeck', label: 'Shirt V Neck' },
];

export const CLOTHES_COLOR = [
  { value: '262e33', label: 'Charcoal' },
  { value: '65c9ff', label: 'Maya Blue' },
  { value: '54035D', label: 'Indigo' },
  { value: '5199e4', label: 'Deep Sea Blue' },
  { value: '25557c', label: 'Lapiz Lazuli' },
  { value: '929598', label: 'Battleship Gray' },
  { value: 'AF9183', label: 'Dusty Taupe' },
  { value: 'b1e2ff', label: 'Uranian Blue' },
  { value: '4D2324', label: 'Espresso' },
  { value: '0B3F15', label: 'Forest' },
  { value: '9F1306', label: 'Trender Red' },
  { value: 'ffafb9', label: 'Cherry Blossom' },
  { value: 'ffffb1', label: 'Butter' },
  { value: 'ffffff', label: 'Pearl White' },
];

export const EYES = [
  { value: 'default', label: 'Default' },
  { value: 'closed', label: 'Close' },
  { value: 'cry', label: 'Cry' },
  { value: 'xDizzy', label: 'Dizzy' },
  { value: 'eyeRoll', label: 'Eye Roll' },
  { value: 'happy', label: 'Happy' },
  { value: 'hearts', label: 'Hearts' },
  { value: 'side', label: 'Side' },
  { value: 'squint', label: 'Squint' },
  { value: 'surprised', label: 'Surprised' },
  { value: 'wink', label: 'Wink' },
  { value: 'winkWacky', label: 'Wink Wacky' },
];

export const EYEBROWS = [
  { value: 'default', label: 'Default' },
  { value: 'defaultNatural', label: 'Default Natural' },
  { value: 'angry', label: 'Angry' },
  { value: 'angryNatural', label: 'Angry Natural' },
  { value: 'flatNatural', label: 'Flat' },
  { value: 'frownNatural', label: 'Frown' },
  { value: 'raisedExcited', label: 'Raised Excited' },
  { value: 'raisedExcitedNatural', label: 'Raised Excited Natural' },
  { value: 'sadConcerned', label: 'Sad Concerned' },
  { value: 'sadConcernedNatural', label: 'Sad Concerned Natural' },
  { value: 'unibrowNatural', label: 'Unibrow' },
  { value: 'upDown', label: 'Up Down' },
  { value: 'upDownNatural', label: 'Up Down Natural' },
];

export const MOUTH = [
  { value: 'default', label: 'Default' },
  { value: 'concerned', label: 'Concerned' },
  { value: 'disbelief', label: 'Disbelief' },
  { value: 'eating', label: 'Eating' },
  { value: 'grimace', label: 'Grimace' },
  { value: 'sad', label: 'Sad' },
  { value: 'screamOpen', label: 'Scream Open' },
  { value: 'serious', label: 'Serious' },
  { value: 'smile', label: 'Smile' },
  { value: 'tongue', label: 'Tongue' },
  { value: 'twinkle', label: 'Twinkle' },
];

export const SKIN_COLOR = [
  { value: 'fd9841', label: 'Tanned' },
  { value: 'f8d25c', label: 'Golden' },
  { value: 'ffdbb4', label: 'Fair' },
  { value: 'edb98a', label: 'Light' },
  { value: 'd08b5b', label: 'Medium' },
  { value: 'ae5d29', label: 'Deep' },
  { value: '614335', label: 'Rich' },
];
